import * as React from 'react';
export const jejuSvg = React.forwardRef(function jejuSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#DDB76E',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#DDB76E',
      d: 'M15.463 4.17C8.931 4.465 3.877 10 4.17 16.535c.299 6.532 5.833 11.586 12.362 11.293 6.536-.299 11.59-5.83 11.294-12.365-.287-6.35-5.52-11.305-11.816-11.305-.182 0-.365.006-.547.012Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#015CAD',
      d: 'M13.295 26.17c-1.323-.128-2.906-.546-4.286-1.74-1.27-1.094-2.055-2.6-2.435-3.928-.39-1.356-.555-2.94.09-2.814.197.036.544.908.914 1.544.385.654.696 1.019.992 1.24.131.098.585-.905 1.245-1.479.382-.316.8-.424.872.517.08 1.156-.128 2.533.21 2.533.31 0 1.024-.236 2.586-.37.588-.051.923.06.361.848-.28.394-.654.952-1.54 1.589 1.328 1.242 2.92 1.093 2.95 1.621.018.305-.576.472-1.356.472-.191 0-.394-.012-.603-.033Zm4.471-11.176c-1.219-.254-1.467-1.36-1.467-1.36-.098-.387-.125-.88-.041-1.507.164-1.312.52-1.924.92-2.942.543-1.362-.774-2.16-.559-2.662.296-.678 1.237.186 2.288.248.905.051 1.449.006 2.15.099.935.125 2.052.442 2.551 1.024.457.535-.242 1.186-1.078.78-.615-.299-1.383-.117-.929.523.54.606.8.624 1.359.77 1.526.403 1.56 1.87.523 2.623-1.174.86-2.372.504-2.847-1.186-.239-.842-.833-1.273-1.445-1.03-.604.235-.245 1.346.215 2.374.797 2.04-.816 2.255-1.437 2.255-.095 0-.17-.006-.203-.01Zm-.878 11.559c-.012-.272.385-.338.385-.338 3.551-.702 2.512-3.028 1.258-4.217-.53-.496-5.472-4.764-5.472-4.764-4.71-4.056-4.334-7.222-4.334-7.222.233-3.898 3.64-4.863 6.221-4.639.305.027.472.21.416.46-.054.275-.454.293-.454.293-.822.05-1.556.132-2.115.508-2.079 1.398-1.47 3.778 1.305 6.43.35.332.72.684 1.105 1.043 0 0 .553.49 1.664 1.544a921.11 921.11 0 0 0 3.3 3.026c3.764 3.13 2.473 5.994 1.04 6.986-1.096.761-2.312 1.117-3.904 1.2-.012 0-.027.003-.042.003-.146 0-.364-.09-.373-.32M15.454 4.012c-6.616.3-11.74 5.908-11.442 12.53.298 6.619 5.91 11.744 12.53 11.445 6.618-.298 11.746-5.907 11.445-12.53C27.697 9.018 22.387 4 16.004 4c-.182 0-.368.003-.55.011Z',
    }),
  );
});
jejuSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var jeju = {
  category: 'brand',
  colorable: false,
  name: 'jeju',
  svg: jejuSvg,
};
